const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const frenchFormatter = new Intl.NumberFormat('fr-CA', {
  style: 'currency',
  currency: 'CAD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (
  price: number | null | undefined,
  isFrench?: boolean,
  shouldBeNegative?: boolean,
): string => {
  if (!price) return '—';
  const formatted = isFrench ? frenchFormatter.format(price) : formatter.format(price);
  if (price > 0 && shouldBeNegative) {
    return `-${formatted}`;
  }
  return formatted;
};
